import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import { bannerInfo } from "../VipJumbotronFunc";
import VipMaintenanceBulletin from "../VipMaintenanceBulletin";
import './vipportal.css';

const VipWireReportPortal = ({ match }) => {
  const gameId = match.params.game_id;
  
  const [maintenanceBulletin, setMaintenanceBulletin] = useState(null);

  useEffect(() => {
    async function fetchMaintenanceBulletin() {
      const result = await axios(`/api/vipv3/maintenance`);
      
      if (result.data.msg==="OK") {
        setMaintenanceBulletin(result.data.bulletin);
      }
    }
    fetchMaintenanceBulletin();
   
  }, []);

  const [gameFlag, setGameFlag] = useState(0);
  
  useEffect(() => {
    async function fetchGamesData(gameId) {
      const result = await axios(`/api/vipv3/game/${gameId}`);
      //console.log("result", result.data.os);
      if (result.data.os===1) {
        setGameFlag(result.data.os);
      } else {
        window.location.replace('/game');
      }
    }
    fetchGamesData(gameId);
   
  }, [gameId]); // Or [] if effect doesn't need props or state

  const banner = bannerInfo(gameId);
  
  if (maintenanceBulletin) {
    return <VipMaintenanceBulletin game_id={gameId} maintenanceBulletin={maintenanceBulletin} />
  } 
  
  if (gameFlag!==1) {
    return <div></div>;
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6  col-sm-12  mt-3">{banner}</div>
        <div className="col-lg-3 mt-3"> </div>
      </div>
      <div className="row">
        <div className="col-lg-3 mt-3"> </div>
        <div className="col-lg-6 col-sm-12 mt-3">
          <div className='row justify-content-center'>
            <div className='col-sm-6 col-xs-6 col-md-6'>                      
              <Link to={`/wire_report_v2/${gameId}`} className='quick-button-vip'>
                <i className='fa fa-store-alt' />
                <p style={{ padding: '10px' }}>台灣地區</p>
              </Link>
            </div>
            <div className='col-sm-6 col-xs-6 col-md-6'>
              <Link to={`/wire_report_v3/${gameId}`} className='quick-button-vip'>
                <i className='fa fa-globe-asia' />
                <p style={{ padding: '10px' }}>海外地區</p>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VipWireReportPortal;
